import React from 'react';
import ReactMarkdown from 'react-markdown';

import { StatementsProps } from './types';
import styles from './styles.module.css';

export const Statements: React.FC<StatementsProps> = ({ markdown }) => {
  return (
    <div
      className={styles.statementsContainer}
      data-testid="statements-container"
    >
      {markdown && (
        <ReactMarkdown className={styles.markdownContent} skipHtml={true}>
          {markdown}
        </ReactMarkdown>
      )}
    </div>
  );
};
